import "./style.scss";
import "swiper/css";
import "swiper/css/navigation";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperClass } from "swiper/types";
import { Navigation } from "swiper/modules";
import bannerSliderSlideOne from "@/src/assets/HomePage/BannerSlider/banner-slider-slide-1.png";
import { Arrow } from "@/src/svg/Arrow";
import { Link } from "react-router-dom";
import BanerLogo from "@/src/assets/HomePage/BannerSlider/banner-white.png";

const BannerSliderDesk = () => {
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="banner-slider">
      <Swiper
        modules={[Navigation]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        navigation={{
          prevEl: prevRef.current!,
          nextEl: nextRef.current!,
        }}
        onBeforeInit={(swiper: SwiperClass) => {
          if (typeof swiper.params.navigation !== "boolean" && swiper.params.navigation) {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }
        }}
      >
        <SwiperSlide>
          <div className="banner-slider-background">
            <img src={bannerSliderSlideOne} alt="Banner Slider Img" />
          </div>
          <div className="banner-slider-logo">
            <img src={BanerLogo} alt="Logo" />
          </div>
          <div className="banner-slider-content">
            <div className="banner-slider-title">
              <p>Начни свой путь к европейскому диплому!</p>
            </div>
            <div className="banner-slider-subtitle">
              <p>Мальтийская школа медицины и бизнеса</p>
            </div>
            <div className="banner-slider-buttons">
              {/* <Link to={"/"} className="btn-default">
                Подобрать программу
              </Link> */}
              <Link to={"/apply-online"} className="btn-default reverse">
                Оставить заявку
              </Link>
            </div>
            {/* <div className="banner-slider-account">
              <div className="banner-slider-account-svg">
                <div className="first">
                  <div className="second">
                    <Account />
                  </div>
                </div>
              </div>
              <div className="banner-slider-account-text">
                <p>Sign in</p>
              </div>
              <div className="banner-slider-account-dash">|</div>
              <div className="banner-slider-account-text">
                <p>Registration</p>
              </div>
            </div> */}
          </div>
        </SwiperSlide>
        {/* <SwiperSlide>
          <div className="banner-slider-background">
            <img src={bannerSliderImg} alt="Banner Slider Img" />
          </div>
          <div className="banner-slider-content">
            <div className="banner-slider-title">
              <p>Начни свой путь к европейскому диплому2</p>
            </div>
            <div className="banner-slider-subtitle">
              <p>Мальтийская школа медицины и бизнеса</p>
            </div>
            <div className="banner-slider-buttons">
              <Link to={"/"} className="btn-default">
                Подобрать программу
              </Link>
              <Link to={"/"} className="btn-default reverse">
                Оставить заявку
              </Link>
            </div>
             <div className="banner-slider-account">
              <div className="banner-slider-account-svg">
                <div className="first">
                  <div className="second">
                    <Account />
                  </div>
                </div>
              </div>
              <div className="banner-slider-account-text">
                <p>Sign in</p>
              </div>
              <div className="banner-slider-account-dash">|</div>
              <div className="banner-slider-account-text">
                <p>Registration</p>
              </div>
            </div> 
          </div>
        </SwiperSlide> */}
        {/* <SwiperSlide>
          <div className="banner-slider-background">
            <img src={bannerSliderImg} alt="Banner Slider Img" />
          </div>
          <div className="banner-slider-content">
            <div className="banner-slider-title">
              <p>Начни свой путь к европейскому диплому3</p>
            </div>
            <div className="banner-slider-subtitle">
              <p>Мальтийская школа медицины и бизнеса</p>
            </div>
            <div className="banner-slider-buttons">
              <Link to={"/"} className="btn-default">
                Подобрать программу
              </Link>
              <Link to={"/"} className="btn-default reverse">
                Оставить заявку
              </Link>
            </div>
            <div className="banner-slider-account">
              <div className="banner-slider-account-svg">
                <div className="first">
                  <div className="second">
                    <Account />
                  </div>
                </div>
              </div>
              <div className="banner-slider-account-text">
                <p>Sign in</p>
              </div>
              <div className="banner-slider-account-dash">|</div>
              <div className="banner-slider-account-text">
                <p>Registration</p>
              </div>
            </div>
          </div>
        </SwiperSlide> */}
        {/* <button className="banner-slider-button prev" ref={prevRef}>
          <Arrow />
        </button>
        <button className="banner-slider-button next" ref={nextRef}>
          <Arrow />
        </button> */}
      </Swiper>
    </div>
  );
};

export default BannerSliderDesk;
